// extracted by mini-css-extract-plugin
export default {"container":"GO-z","topReviewHeading":"HO-z","criticalReview":"IO-z","favorableReview":"JO-z","vsSeparator":"KO-z"};